import React, { useContext, ReactElement } from "react";
import { useTextDomainContext } from "@/app/providers";
import { useAllowRegistration } from "@/hooks";
import { Stack, Typography } from "@mui/material";
import { Link } from "react-router";

/**
 * ForgotPasswordLinkSection component renders navigation links for the forgot password page.
 * Displays links to sign in and optionally sign up depending on allowRegistration setting.
 */
export const ForgotPasswordLinkSection = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { allowRegistration } = useAllowRegistration();

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "baseline",
        justifyContent: "center",
        mt: {
          xl: 4,
        },
        mb: {
          xs: -0.5,
          sm: 0.5,
        },
      }}
    >
      <Typography variant="body2">{gettext("Back to")}</Typography>
      <Typography sx={{ fontSize: 16, fontWeight: 500 }}>&nbsp;</Typography>
      <Typography
        component={Link}
        to="/auth/login"
        sx={{
          textDecoration: "none",
          fontSize: 16,
          fontWeight: 500,
          color: "primary",
        }}
      >
        {gettext("Sign in")}
      </Typography>
      <Typography sx={{ fontSize: 16, fontWeight: 500 }}>&nbsp;</Typography>
      {allowRegistration && (
        <>
          <Typography variant="body2">{gettext("or")}</Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 500 }}>&nbsp;</Typography>
          <Typography
            component={Link}
            to="/auth/register"
            sx={{
              textDecoration: "none",
              fontSize: 16,
              fontWeight: 500,
              color: "primary",
            }}
          >
            {gettext("Sign up")}
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 500 }}>&nbsp;</Typography>
        </>
      )}
      <Typography variant="body2">{gettext("page")}</Typography>
    </Stack>
  );
};
